module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    on: {
      "prevent": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "submit", undefined, $event.key, undefined)) { return null; }
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "a-table a-table--really-wide"
  }, [_c('table', {
    staticClass: "a-table--full-width",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.periods), function(period, periodIndex) {
    return _c('income-period', {
      attrs: {
        "start-disabled": _vm.startDisabled,
        "period": period,
        "index": periodIndex,
        "dependant": _vm.index,
        "maxIndex": _vm.periodsLength,
        "retired": _vm.retired,
        "lossOfEarnings": _vm.lossOfEarnings,
        "type": _vm.type
      },
      on: {
        "update": _vm.updatePeriod
      }
    })
  })], 2)]), _vm._v(" "), _c('button', {
    staticClass: "a-button",
    attrs: {
      "type": "button",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addIncomePeriod('future')
      }
    }
  }, [_vm._v("\n            Add another period\n        ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("From")]), _vm._v(" "), _c('th', [_vm._v("To")]), _vm._v(" "), _c('th', [_vm._v("Employment Type")]), _vm._v(" "), _c('th', [_vm._v("Total Income per Annum")]), _vm._v(" "), _c('th', [_vm._v("Income Type")]), _vm._v(" "), _c('th', [_vm._v("Total Net Income per Annum")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', [_vm._v("Delete Period")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0c9a5f8d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/personal-injury-claims/steps/income/FutureIncome.vue
// module id = 1569
// module chunks = 0